(function () {
  const HERO_HANDLES = ['question-mark-lamp', 'mushroom-ice-mold', 'fruit-bath-mat'];

  function getCatalog() {
    const el = document.getElementById('zeniqas-hero-catalog');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartItems() {
    return document.querySelector('cart-items');
  }

  function renderCartPageSections(data) {
    const cartItems = getCartItems();
    if (!cartItems || !data.sections || typeof cartItems.getSectionsToRender !== 'function') return;

    cartItems.getSectionsToRender().forEach((section) => {
      const sectionRoot = document.getElementById(section.id);
      if (!sectionRoot || !data.sections[section.section]) return;
      const elementToReplace =
        sectionRoot.querySelector(section.selector) || sectionRoot;
      elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
        data.sections[section.section],
        section.selector
      );
    });

    if (typeof data.item_count === 'number') {
      cartItems.classList.toggle('is-empty', data.item_count === 0);
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', data.item_count === 0);
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  async function addVariant(variantId, source) {
    const cartDrawer = getCartDrawer();
    const cartItems = getCartItems();
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    const sectionIds = [];
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sectionIds.push(...cartDrawer.getSectionsToRender().map((section) => section.id));
    }
    if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
      sectionIds.push(...cartItems.getSectionsToRender().map((section) => section.section));
    }
    if (sectionIds.length) {
      formData.append('sections', [...new Set(sectionIds)].join(','));
      formData.append('sections_url', window.location.pathname);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    const response = await fetch(`${routes.cart_add_url}`, config);
    const data = await response.json();
    if (data.status) throw new Error(data.description || 'Could not add to cart');

    if (typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: source || 'zeniqas-cro',
        productVariantId: variantId,
        cartData: data,
      });
    }

    if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(data);
    }

    renderCartPageSections(data);

    return data;
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('loading', loading);
    button.toggleAttribute('disabled', loading);
  }

  document.addEventListener('click', async (event) => {
    const addButton = event.target.closest('[data-zeniqas-bundle-add]');
    if (!addButton || addButton.disabled) return;

    event.preventDefault();
    const variantId = addButton.getAttribute('data-zeniqas-bundle-add');
    if (!variantId) return;

    const mobileBar = addButton.closest('#zeniqas-mobile-buy-bar');
    const mobileError = mobileBar?.querySelector('[data-zeniqas-mobile-error]');
    if (mobileError) { mobileError.hidden = true; mobileError.textContent = ''; }
    let phoneError;
    if (window.matchMedia('(max-width: 749px)').matches && !mobileError) {
      phoneError = addButton.nextElementSibling;
      if (!phoneError?.matches('[data-zq-action-error]')) {
        phoneError = document.createElement('p');
        phoneError.setAttribute('data-zq-action-error', '');
        phoneError.setAttribute('role', 'alert');
        addButton.after(phoneError);
      }
      phoneError.hidden = true;
      phoneError.textContent = '';
    }
    setButtonLoading(addButton, true);
    try {
      await addVariant(variantId, 'zeniqas-cro');
    } catch (e) {
      if (mobileError) { mobileError.textContent = e.message; mobileError.hidden = false; }
      if (phoneError) { phoneError.textContent = e.message; phoneError.hidden = false; }
      console.error(e);
    } finally {
      setButtonLoading(addButton, false);
    }
  });

  function isWalletInteractive(walletRoot) {
    if (!walletRoot) return false;
    return !!(
      walletRoot.querySelector('iframe') ||
      walletRoot.querySelector('.shopify-payment-button__button--branded') ||
      walletRoot.querySelector('shopify-accelerated-checkout iframe') ||
      walletRoot.querySelector('shopify-accelerated-checkout-cart iframe') ||
      walletRoot.querySelector('.wallet-cart-button:not(.wallet-cart-button__skeleton)') ||
      walletRoot.querySelector('[data-testid="PayPalInContext-button"]') ||
      walletRoot.querySelector('shopify-accelerated-checkout:not(:has(.shopify-payment-button__skeleton))') ||
      walletRoot.querySelector('shopify-accelerated-checkout-cart:not(:has(.wallet-cart-button__skeleton))')
    );
  }

  function hideInlineAtc(buttonsHost) {
    if (!buttonsHost) return;
    buttonsHost.querySelectorAll('.product-form__submit, button[name="add"]').forEach((btn) => {
      if (btn.closest('.zeniqas-mobile-buy-bar')) return;
      btn.classList.add('zeniqas-inline-atc--hidden');
    });
  }

  function initMobileBuyBar() {
    const bar = document.getElementById('zeniqas-mobile-buy-bar');
    if (!bar || window.matchMedia('(min-width: 750px)').matches) return;

    const productHandle = bar.dataset.productHandle || '';
    document.body.classList.add('zeniqas-mobile-pdp-bar');
    if (HERO_HANDLES.includes(productHandle)) {
      document.body.classList.add('zeniqas-hero-pdp');
    }

    const sectionId = bar.dataset.sectionId;
    const mainForm = document.getElementById(bar.dataset.productFormId);
    if (!mainForm) return;

    const productForm = mainForm.closest('product-form') || mainForm.parentElement;
    const buttonsHost =
      productForm?.querySelector('.product-form__buttons') || mainForm.querySelector('.product-form__buttons');

    const mainVariant = mainForm.querySelector('[name="id"]');
    const stickyAtc = bar.querySelector('.zeniqas-mobile-buy-bar__atc');
    const inlineAtc = buttonsHost?.querySelector('[name="add"]');
    mainForm.appendChild(bar);
    const syncStickyAtc = () => {
      if (!stickyAtc || !inlineAtc) return;
      const variantId = inlineAtc.getAttribute('data-zeniqas-bundle-add') || mainVariant?.value;
      if (variantId) stickyAtc.setAttribute('data-zeniqas-bundle-add', variantId);
      stickyAtc.disabled = inlineAtc.disabled || stickyAtc.classList.contains('loading');
      stickyAtc.textContent = inlineAtc.textContent.trim();
    };
    if (inlineAtc) {
      new MutationObserver(syncStickyAtc).observe(inlineAtc, {
        attributes: true, attributeFilter: ['data-zeniqas-bundle-add', 'disabled'],
        childList: true, subtree: true
      });
    }
    const mainPrice = document.getElementById(`price-${sectionId}`);
    const mobilePrice = document.getElementById(`zeniqas-mobile-buy-price-${sectionId}`);
    const foldPrice = document.getElementById(`zeniqas-fold-price-${sectionId}`);

    const syncPrice = () => {
      if (!mainPrice) return;
      if (mobilePrice) mobilePrice.innerHTML = mainPrice.innerHTML;
      if (foldPrice) foldPrice.innerHTML = mainPrice.innerHTML;
    };

    const syncVariant = () => {
      syncStickyAtc();
      syncPrice();
    };

    mainVariant?.addEventListener('change', syncVariant);

    if (mainPrice) {
      const observer = new MutationObserver(syncVariant);
      observer.observe(mainPrice, { childList: true, subtree: true, characterData: true });
    }

    syncVariant();
    hideInlineAtc(buttonsHost);

  }

  function initCartDrawerWallets() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const nudgeDrawerWallets = () => {
      const checkoutZone =
        drawer.querySelector('.cart-drawer__dynamic-checkout') ||
        drawer.querySelector('shopify-accelerated-checkout-cart');
      if (!checkoutZone) return;

      window.dispatchEvent(new Event('resize'));
      if (isWalletInteractive(checkoutZone)) {
        checkoutZone.classList.add('zeniqas-wallet-ready');
      }
    };

    const scheduleDrawerWalletNudges = () => {
      [0, 350, 1000, 2500].forEach((delay) => {
        window.setTimeout(nudgeDrawerWallets, delay);
      });
    };

    const observer = new MutationObserver(() => {
      if (drawer.classList.contains('active')) scheduleDrawerWalletNudges();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        if (drawer.classList.contains('active')) scheduleDrawerWalletNudges();
      });
    }
  }

  function syncBuyBarWalletPause() {
    const anyOpen = document.querySelector(
      '.template-product .product__accordion details[open], .template-product .accordion details[open]'
    );
    document.body.classList.toggle('zeniqas-buy-bar-wallet-paused', !!anyOpen);
  }

  function initBuyBarAccordionGuard() {
    if (!document.getElementById('zeniqas-mobile-buy-bar')) return;

    const onToggle = () => syncBuyBarWalletPause();
    document
      .querySelectorAll('.template-product .product__accordion details, .template-product .accordion details')
      .forEach((details) => {
        details.addEventListener('toggle', onToggle);
      });
    syncBuyBarWalletPause();
  }

  function guardStaticEdd() {
    document.querySelectorAll('[data-zeniqas-edd-static]').forEach((el) => {
      const fallback = el.innerHTML;
      const observer = new MutationObserver(() => {
        if (/calculating/i.test(el.textContent || '')) {
          el.innerHTML = fallback;
        }
      });
      observer.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  function hideJudgeMeStoreReviewsTab() {
    const widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;

    widget.querySelectorAll('[role="tab"], .jdgm-rev-widg__tab, button[class*="tab"]').forEach((tab) => {
      const label = (tab.textContent || '').trim().toLowerCase();
      if (!label.includes('store review')) return;
      tab.setAttribute('data-zeniqas-hidden-store-tab', 'true');
      tab.hidden = true;
      tab.setAttribute('aria-hidden', 'true');
      tab.style.display = 'none';
    });

    widget.querySelectorAll('[data-tab-content="store-reviews"], [class*="store-review"]').forEach((panel) => {
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      panel.style.display = 'none';
    });

    widget.querySelectorAll('.jdgm-rev-widg__tabs, .jdgm-rev-widg__tab-list').forEach((tabList) => {
      const visibleTabs = Array.from(tabList.querySelectorAll('[role="tab"], .jdgm-rev-widg__tab')).filter(
        (tab) => tab.style.display !== 'none' && !tab.hidden
      );
      if (visibleTabs.length <= 1) {
        tabList.style.display = 'none';
      }
    });
  }

  const STALE_VARIANT_PATTERN = /\b(strawberry|strawberries|lemon|lemons)\b/i;

  function sanitizeStaleVariantText(text) {
    if (!text || !STALE_VARIANT_PATTERN.test(text)) return text;
    return text
      .replace(/\bkiwi\s+and\s+strawberr(?:y|ies)\b/gi, 'kiwi')
      .replace(/\bstrawberr(?:y|ies)\s+and\s+kiwi\b/gi, 'kiwi')
      .replace(/,\s*strawberr(?:y|ies)\b/gi, '')
      .replace(/\bstrawberr(?:y|ies)\b/gi, '')
      .replace(/\blemons?\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .replace(/\s+([.,!;:?])/g, '$1')
      .trim();
  }

  function setReviewText(el, next) {
    if (!el || !next) return;
    const paragraph = el.querySelector('p');
    if (paragraph) {
      paragraph.textContent = next;
      return;
    }
    el.textContent = next;
  }

  function hideStaleVariantReview(review) {
    review.setAttribute('data-zeniqas-stale-variant-review', 'true');
    review.hidden = true;
    review.setAttribute('aria-hidden', 'true');
    review.style.display = 'none';
  }

  function sanitizeJudgeMeStaleVariantCopy() {
    document.querySelectorAll('.jdgm-rev').forEach((review) => {
      const bodyEl = review.querySelector('.jdgm-rev__body');
      const titleEl = review.querySelector('.jdgm-rev__title');
      const raw = `${titleEl?.textContent || ''} ${bodyEl?.textContent || ''}`.trim();
      if (!STALE_VARIANT_PATTERN.test(raw)) return;

      const nextBody = sanitizeStaleVariantText(bodyEl?.textContent || '');
      const nextTitle = sanitizeStaleVariantText(titleEl?.textContent || '');
      if (STALE_VARIANT_PATTERN.test(`${nextTitle} ${nextBody}`) || nextBody.length < 8) {
        hideStaleVariantReview(review);
        return;
      }

      setReviewText(bodyEl, nextBody);
      if (titleEl && nextTitle) setReviewText(titleEl, nextTitle);
    });

    document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
      if (!STALE_VARIANT_PATTERN.test(script.textContent || '')) return;
      try {
        const data = JSON.parse(script.textContent);
        const patch = (node) => {
          if (!node || typeof node !== 'object') return;
          if (typeof node.reviewBody === 'string') {
            node.reviewBody = sanitizeStaleVariantText(node.reviewBody);
          }
          if (Array.isArray(node.review)) node.review.forEach(patch);
          Object.values(node).forEach((value) => {
            if (value && typeof value === 'object') patch(value);
          });
        };
        patch(data);
        script.textContent = JSON.stringify(data);
      } catch (_err) {
        /* ignore malformed JSON-LD */
      }
    });
  }

  function hideJudgeMeImportedReviews() {
    document.querySelectorAll('.jdgm-rev').forEach((review) => {
      const text = (review.textContent || '').toLowerCase();
      if (
        text.includes('aliexpress') ||
        text.includes('imported review') ||
        text.includes('store visitor') ||
        review.querySelector('[data-source="aliexpress"]')
      ) {
        review.setAttribute('data-zeniqas-imported-review', 'true');
        review.hidden = true;
        review.setAttribute('aria-hidden', 'true');
        review.style.display = 'none';
      }
    });
  }

  function hideJudgeMeReviewBadges() {
    const selectors = [
      '.jdgm-rev__buyer-badge',
      '.jdgm-rev__verified',
      '.jdgm-verified-checkmark',
      '.jdgm-rev__transparency-badge',
      '[class*="transparency-badge"]',
      '[class*="jdgm-transparency"]',
    ].join(', ');

    document.querySelectorAll(selectors).forEach((el) => {
      el.remove();
    });

    document.querySelectorAll('.jdgm-rev').forEach((review) => {
      review.querySelectorAll('[class*="badge"], [class*="verified"], [data-verified]').forEach((el) => {
        const label = (el.textContent || '').trim().toLowerCase();
        if (
          !label ||
          label.includes('verified') ||
          label.includes('unverified') ||
          label.includes('imported') ||
          label.includes('store visitor') ||
          label.includes('aliexpress')
        ) {
          el.remove();
        }
      });
    });
  }

  function selectProductVariant(variantId, labelHint) {
    if (!variantId) return false;

    const idInput = document.querySelector(
      `form[action*="/cart/add"] input[name="id"][value="${variantId}"]`
    );
    if (idInput) {
      idInput.checked = true;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    const radios = document.querySelectorAll('variant-radios input[type="radio"]');
    for (const radio of radios) {
      if (radio.value === String(variantId)) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    if (labelHint) {
      const hint = labelHint.toLowerCase();
      for (const radio of radios) {
        const label = (radio.labels?.[0]?.textContent || radio.value || '').toLowerCase();
        if (label.includes(hint)) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      }
    }

    const select = document.querySelector('variant-selects select[name="id"], select[name="id"]');
    if (select) {
      select.value = String(variantId);
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  function initLampPairUpsell() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-zeniqas-select-variant]');
      if (!button) return;
      event.preventDefault();
      const variantId = button.getAttribute('data-zeniqas-select-variant');
      const labelHint = button.getAttribute('data-zeniqas-select-variant-label') || '';
      if (selectProductVariant(variantId, labelHint)) {
        button.setAttribute('aria-pressed', 'true');
        const card = button.closest('.zeniqas-lamp-pair');
        if (card) {
          card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      }
    });
  }

  function hideJudgeMePopupWidgets() {
    document
      .querySelectorAll(
        '.jdgm-rev-snippet-widget, .jdgm-popup-widget, [class*="jdgm-popup"], [id*="jdgm-popup"], .jdgm-widget-popup'
      )
      .forEach((el) => {
        el.remove();
      });
  }

  function hideJudgeMeReviewTimestamps() {
    document.querySelectorAll('#judgeme_product_reviews .jdgm-rev__timestamp').forEach((el) => {
      el.hidden = true;
      el.setAttribute('aria-hidden', 'true');
      el.style.display = 'none';
    });
  }

  function initJudgeMeCleanup() {
    const cleanup = () => {
      hideJudgeMeStoreReviewsTab();
      sanitizeJudgeMeStaleVariantCopy();
      hideJudgeMeImportedReviews();
      hideJudgeMeReviewBadges();
      hideJudgeMePopupWidgets();
      hideJudgeMeReviewTimestamps();
    };

    cleanup();
    const roots = [
      document.getElementById('judgeme_product_reviews'),
      document.querySelector('.jdgm-all-reviews-widget'),
      document.querySelector('.jdgm-ssr-reviews'),
    ].filter(Boolean);
    if (!roots.length) return;
    const observer = new MutationObserver(cleanup);
    roots.forEach((root) => observer.observe(root, { childList: true, subtree: true }));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMobileBuyBar();
    initBuyBarAccordionGuard();
    initCartDrawerWallets();
    guardStaticEdd();
    initLampPairUpsell();
    initJudgeMeCleanup();
  });
})();

